/**
 * CTS Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The PlatformDto model module.
 * @module model/PlatformDto
 * @version v1.0.0
 */
class PlatformDto {
    /**
     * Constructs a new <code>PlatformDto</code>.
     * @alias module:model/PlatformDto
     */
    constructor() { 
        
        PlatformDto.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>PlatformDto</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/PlatformDto} obj Optional instance to populate.
     * @return {module:model/PlatformDto} The populated <code>PlatformDto</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new PlatformDto();

            if (data.hasOwnProperty('description')) {
                obj['description'] = ApiClient.convertToType(data['description'], 'String');
            }
            if (data.hasOwnProperty('fileUrl')) {
                obj['fileUrl'] = ApiClient.convertToType(data['fileUrl'], 'String');
            }
            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'String');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('seq')) {
                obj['seq'] = ApiClient.convertToType(data['seq'], 'Number');
            }
        }
        return obj;
    }


}

/**
 * description
 * @member {String} description
 */
PlatformDto.prototype['description'] = undefined;

/**
 * file url
 * @member {String} fileUrl
 */
PlatformDto.prototype['fileUrl'] = undefined;

/**
 * id
 * @member {String} id
 */
PlatformDto.prototype['id'] = undefined;

/**
 * name
 * @member {String} name
 */
PlatformDto.prototype['name'] = undefined;

/**
 * seq
 * @member {Number} seq
 */
PlatformDto.prototype['seq'] = undefined;






export default PlatformDto;

